import styled from 'styled-components';
import { shade } from 'polished';
import BotaoComConfirmacao from '../../../../../../components/Botoes/BotaoComConfirmacao';
import {
  backgroundColorLigthButton,
  colorLigthButton,
  backgroundColorDarkButton,
  colorDarkButton,
  backgroundColorSuccess,
  colorSuccess,
  backgroundColorError,
  colorError,
  darkFontColor,
} from '../../../../../../config/Colors/Ligth';

export const BotaoOAuthConnect = styled(BotaoComConfirmacao)`
  && {
    background: ${backgroundColorLigthButton};
    color: ${colorLigthButton};
    max-height: 100%;
    height: 38px; /* Altura definida explicitamente */
    display: flex;
    justify-content: center;
    cursor: pointer;
    border: none;
    padding: 10px 10px;
    border-radius: 4px;
    transition: all 200ms;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
    align-items: center;

    &:disabled {
      background: ${shade(0.3, backgroundColorLigthButton)};
      cursor: not-allowed;
    }

    &:hover {
      background: ${shade(0.3, backgroundColorLigthButton)};
    }

    /* Estilos para garantir que os ícones e texto fiquem alinhados */
    & > svg {
      display: inline-flex;
      vertical-align: middle;
    }

    & > span {
      display: inline-flex;
      align-items: center;
    }
  }
`;

export const BotaoOAuthDisconnect = styled(BotaoComConfirmacao)`
  && {
    background-color: ${backgroundColorDarkButton};
    color: ${colorDarkButton};
    border-radius: 4px;
    padding: 10px 16px;
    height: 38px; /* Altura definida explicitamente */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 200ms;
    border: none;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;

    /* Estilos para garantir que os ícones e texto fiquem alinhados */
    & > svg {
      display: inline-flex;
      vertical-align: middle;
    }

    & > span {
      display: inline-flex;
      align-items: center;
    }

    &:hover {
      background-color: ${shade(0.3, backgroundColorDarkButton)};
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
`;

export const ConnectorContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

// Container para alinhar os status e botões horizontalmente
export const StatusButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ConnectionStatus = styled.div`
  height: 38px; /* Mesma altura dos botões */
  padding: 0 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  flex: 1;
  color: ${darkFontColor};
`;

export const ConnectedStatus = styled(ConnectionStatus)`
  background-color: ${backgroundColorSuccess};
  color: ${colorSuccess};
  border: 1px solid ${shade(0.1, backgroundColorSuccess)};
  font-weight: 600; /* Texto um pouco mais forte */

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: ${colorSuccess};
    border-radius: 50%;
    margin-right: 8px;
  }
`;

export const DisconnectedStatus = styled(ConnectionStatus)`
  background-color: ${backgroundColorError};
  color: ${colorError};
  border: 1px solid ${shade(0.1, backgroundColorError)};
  font-weight: 600; /* Texto um pouco mais forte */

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: ${colorError};
    border-radius: 50%;
    margin-right: 8px;
  }
`;

// Margens para os botões
export const ButtonContainer = styled.div`
  margin-left: 16px;
`;
